/* ============================================================
   Option card — a large touch target with a real pressed state.
   ============================================================ */

import { html } from '../shared/html.js';

export function OptionCard({ label, selected, onClick, notApplicable = false }) {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'option-card';
  button.setAttribute('aria-pressed', selected ? 'true' : 'false');

  button.innerHTML = html`
    <span class="option-mark" aria-hidden="true"></span>
    <span style="flex: 1;">${label}</span>
    ${notApplicable
      ? html`<span class="badge" style="background: var(--ca-surface-sunk); color: var(--ca-text-quaternary);">
          Not scored
        </span>`
      : ''}
  `;

  button.addEventListener('click', onClick);
  return button;
}
